const checkUserHasEmail = user => !!user.email;
export const convertRpcUsersToInboxUsers = users => users.filter(checkUserHasEmail).map(user => ({
  canViewInbox: user.canViewWorkspace,
  email: user.email,
  firstName: user.firstName || user.email,
  hidden: user.isHidden,
  id: user.userId,
  lastName: user.lastName || '',
  routable: user.isRoutable,
  userInPortal: user.isUserInPortal,
  verified: user.isVerified
}));